import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlay, FiArrowDown } = FiIcons;

const HeroSection = ({ startJourney, t }) => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Diamond */}
      <div className="absolute inset-0 flex items-center justify-center">
        <motion.div
          initial={{ scale: 0, rotate: 0 }}
          animate={{ scale: 1, rotate: 360 }}
          transition={{ duration: 2, ease: "easeOut" }}
          className="w-96 h-96 relative"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white via-pantone-blue/30 to-pantone-blue/40 transform rotate-45 rounded-lg shadow-2xl opacity-20"></div>
          <div className="absolute inset-4 bg-gradient-to-br from-white via-pantone-blue/20 to-pantone-blue/40 transform rotate-45 rounded-lg shadow-xl opacity-30"></div>
          <div className="absolute inset-8 bg-gradient-to-br from-white via-pantone-blue/10 to-pantone-blue/30 transform rotate-45 rounded-lg shadow-lg opacity-40"></div>
        </motion.div>
      </div>

      {/* Sparkle Effects */}
      {[...Array(20)].map((_, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ 
            opacity: [0, 1, 0],
            scale: [0, 1, 0],
            x: Math.random() * 800 - 400,
            y: Math.random() * 600 - 300
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            delay: Math.random() * 2
          }}
          className="absolute w-2 h-2 bg-white rounded-full"
        />
      ))}

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="text-6xl md:text-8xl font-bold mb-8 bg-gradient-to-r from-white via-[#FFFFFF]/70 to-[#FFFFFF] bg-clip-text text-transparent"
        >
          {t('heroTitle')}
        </motion.h1>
        
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.8 }}
          className="text-4xl md:text-6xl font-light mb-12 bg-gradient-to-r from-white via-[#FFFFFF]/70 to-[#FFFFFF] bg-clip-text text-transparent"
        >
          {t('heroSubtitle')}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="text-xl md:text-2xl text-gray-300 mb-16 leading-relaxed"
        >
          {t('heroDescription')}
        </motion.p>

        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.1, duration: 0.6 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={startJourney}
          className="group relative bg-gradient-to-r from-[#5BB3BE] to-blue-700 hover:from-blue-700 hover:to-[#5BB3BE] text-white px-12 py-6 rounded-full text-xl font-semibold shadow-2xl transition-all duration-300 flex items-center gap-4 mx-auto"
        >
          <SafeIcon icon={FiPlay} className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
          {t('beginJourney')}
          <div className="absolute inset-0 bg-white/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
        </motion.button>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
          className="mt-16"
        >
          <SafeIcon 
            icon={FiArrowDown} 
            className="w-8 h-8 mx-auto animate-bounce text-pantone-blue/80"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSection;